import Vue from 'vue'
import Vuex from 'vuex'
import {getConfigList} from '@/API/home'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: {
      icp:{},
      ga:{},
      phone:{},
      tel:{},
      miniPro:{},
      weChat:{},
      networkId:{},
      settingTitle:{},
      settingKeywords:{},
      settingDescription:{},
    },
  },
  getters: {
    config: (state) => state.config,
  },
  mutations: {
    SETCONFIG: (state, payload) => {
      state.config = payload
    }
  },
  actions: {
    getConfig({commit}, value) {
      return new Promise((resolve, reject) => {
        getConfigList({
          pageNum: 1,
          pageSize: 99,
          configType: 'N'
        }).then(res => {
          const rows = res.rows;
          const config = {
            icp: rows.find((item) => item.configKey === 'icp') || {},
            ga: rows.find((item) => item.configKey === 'ga') || {},
            phone: rows.find((item) => item.configKey === 'phone') || {},
            tel: rows.find((item) => item.configKey === 'tel') || {},
            miniPro: rows.find((item) => item.configKey === 'miniPro') || {},
            weChat: rows.find((item) => item.configKey === 'weChat') || {},
            networkId: rows.find((item) => item.configKey === 'networkId') || {},
            settingTitle: rows.find((item) => item.configKey === 'setting-title') || {},
            settingKeywords: rows.find((item) => item.configKey === 'setting-keywords') || {},
            settingDescription: rows.find((item) => item.configKey === 'description') || {},
            address: rows.find((item) => item.configKey === 'address') || {},
          }
          commit('SETCONFIG', config)
          return resolve(config)
        })
      })
    }
  },
  modules: {}
})
